import React from 'react';
import { authRoles } from 'app/auth';

// Feature: 001-org-multi-tenancy - Organizations Route Config (T034, T066)

export const OrganizationsConfig = {
	settings: {
		layout: {
			config: {}
		}
	},
	// Only super-admin and admin roles can access organizations management
	auth: authRoles.admin,
	routes: [
		{
			path: '/organizations',
			component: React.lazy(() => import('./Organizations'))
		}
	]
};

// Feature: 001-org-multi-tenancy - My Organization Route Config for Org Admins (T066)
export const MyOrganizationConfig = {
	settings: {
		layout: {
			config: {}
		}
	},
	// Any authenticated user can access their organization page
	auth: authRoles.user,
	routes: [
		{
			path: '/my-organization',
			component: React.lazy(() => import('./MyOrganization'))
		}
	]
};
